import TemplateAbout from "Components/Templates/About";

export default function PageAbout() {
   return <TemplateAbout></TemplateAbout>;
}
